import React from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';

/**
 * Atlas is a dark console (same palette as the annotation review panel). antd components
 * get matching tokens so tables, selects and modals sit on the same surfaces.
 */
export const CONSOLE = {
  bg: '#0f1115',
  surface: '#171a21',
  hover: '#1e2230',
  selected: '#22304a',
  ink: '#e6e8ee',
  mute: '#8b93a7',
  line: '#262b36',
  accent: '#5aa9ff',
};

export function antdThemeFor() {
  const p = CONSOLE;
  return {
    algorithm: antdTheme.darkAlgorithm,
    token: {
      colorPrimary: p.accent,
      colorInfo: p.accent,
      colorBgLayout: p.bg,
      colorBgContainer: p.hover,
      colorBgElevated: p.surface,
      colorText: p.ink,
      colorTextSecondary: p.mute,
      colorTextPlaceholder: p.mute,
      colorBorder: p.line,
      colorBorderSecondary: p.line,
      borderRadius: 6,
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      fontSize: 14,
    },
    components: {
      Table: {
        headerBg: p.surface,
        headerColor: p.mute,
        colorBgContainer: p.surface,
        rowHoverBg: p.hover,
        borderColor: p.line,
        headerSplitColor: p.line,
      },
      Select: { optionSelectedBg: p.selected, optionActiveBg: p.hover },
      Modal: { contentBg: p.surface, headerBg: p.surface },
      Pagination: { itemActiveBg: p.selected },
    },
  };
}

export const ThemeModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ConfigProvider theme={antdThemeFor()}>{children}</ConfigProvider>
);
